
import { withStyles } from '@material-ui/core';
import Tooltip from './Tooltip';

const ErrorTooltip = withStyles(theme => ({
  tooltip: {
    backgroundColor: theme.palette.accent3[200],
    color: theme.palette.accent3.darkest,
    boxShadow: theme.shadows[1],
    fontSize: 11,
    '& svg': {
      fontSize: '1rem',
    },
  },
  arrow: {
    color: theme.palette.accent3[200],
  },
}))(Tooltip);

export default ErrorTooltip;
